import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.815 5.355a2.667 2.667 0 1 0-.943.943L7.575 8 5.872 9.703a2.667 2.667 0 1 0 .943.943l2.17-2.17.004-.005.004-.004 5.33-5.329a.667.667 0 0 0-.944-.943L8.519 7.057zM4.518 2.667a1.333 1.333 0 1 0 0 2.666 1.333 1.333 0 0 0 0-2.666m0 8a1.333 1.333 0 1 0 0 2.666 1.333 1.333 0 0 0 0-2.666",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.692 9.182a.667.667 0 0 1 .943 0l3.687 3.68a.667.667 0 0 1-.942.943l-3.687-3.68a.667.667 0 0 1 0-.943"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })